import { render, staticRenderFns } from "./FarmersReg.vue?vue&type=template&id=66018c80&"
import script from "./FarmersReg.vue?vue&type=script&lang=js&"
export * from "./FarmersReg.vue?vue&type=script&lang=js&"
import style0 from "./FarmersReg.vue?vue&type=style&index=0&id=66018c80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports